import { createFileRoute, redirect } from "@tanstack/react-router";

/// `/invite?token=…` is the legacy invite landing URL emailed by cavort-auth.
/// cavort-auth's signup page handles the actual accept-invite flow when
/// `inviteToken` is passed, so this route just forwards the token through.
export const Route = createFileRoute("/_auth/invite")({
	validateSearch: (search: Record<string, unknown>) => ({
		token: typeof search.token === "string" ? search.token : undefined,
	}),
	beforeLoad: ({ search }) => {
		throw redirect({
			to: "/signup",
			search: { invite: search.token ?? "" },
		});
	},
});
